import React, { useEffect } from 'react';
import { ProductType } from '../../common/CommonTypes';
import '../vehicle/SelectableVehicles.scss';
import { useTranslation } from 'react-i18next';
import { TranslationHelper } from '../../../classes/TranslationHelper';
import { useLocaleFormatter } from '../../hooks/useLocaleFormatter';

type ProductProps = {
    id: string;
    product: ProductType;
};

const Product = React.memo(ProductMemo);

function ProductMemo({ id, product }: ProductProps): JSX.Element {
    const { reference, type, expiryDate, status } = product;
    const { toLocalDate } = useLocaleFormatter();
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div id={id} className='vehicle--container'>
            <section className='vehicle--info'>
                <b>
                    {reference} - {t(status)}
                </b>
                <br />
                {t('product_type')}:{' '}
                {`${TranslationHelper.getTranslatedText(`${type}`, 'product_types')}`}
                <br />
                {t('expiry_label')}: {toLocalDate(expiryDate)}
            </section>
        </div>
    );
}

export default Product;
